let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4cEzx")).then(() => parcelRequire('igYJ8'));